
//0～9:プライベート。本人以外見れない
//10～29:リンクを知っている人は見れる
//30～:検索対象。

//[duplicated] 同じ定義がkiwi側（Back）、Melon（Back）にもあるので値を変える場合は一緒に変更すること
export const PublicPagePrivacyLevel = {
	PRIVATE: 0,
	LINK_ONLY: 10,
	SEARCHABLE: 30,
} as const;

type ProjectPrivacyLevelType = typeof PublicPagePrivacyLevel
export type PublicPagePrivacyLevelEnum = ProjectPrivacyLevelType[keyof ProjectPrivacyLevelType]


